<template>
  <v-row dense align="center" class="horario-periodo-filtro">
    <v-col cols="12" sm="8" md="6" lg="5">
      <v-btn
        class="horario-periodo-filtro__date-btn"
        color="primary"
        outlined
        @click="dialogPeriodo = true"
      >
        <v-icon left small>mdi-calendar-range</v-icon>
        {{ periodoLabel }}
      </v-btn>

      <div v-if="dataFimErrors.length" class="error--text text-caption mt-1">
        {{ dataFimErrors[0] }}
      </div>
    </v-col>

    <v-col cols="12" sm="auto" class="horario-periodo-filtro__actions">
      <v-btn color="primary" :disabled="botaoDesabilitado" @click="buscar">
        <v-icon left small>mdi-magnify</v-icon>
        Buscar
      </v-btn>

      <v-btn
        color="red darken-1"
        class="horario-periodo-filtro__pdf-btn"
        dark
        :disabled="botaoDesabilitado"
        @click="gerarPdf"
      >
        <v-icon left small>mdi-file-pdf</v-icon>
        PDF
      </v-btn>

      <v-btn color="primary" outlined :disabled="botaoDesabilitado" @click="gerarHighlights">
        <v-icon left small>mdi-chart-box-outline</v-icon>
        Highlights
      </v-btn>
    </v-col>

    <v-dialog v-model="dialogPeriodo" max-width="450">
      <v-card>
        <v-card-title class="text-h5">Selecionar período</v-card-title>

        <v-card-text>
          <v-row justify="center" class="mt-4">
            <v-date-picker v-model="periodoSelecionado" range></v-date-picker>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="dialogPeriodo = false">Cancelar</v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="!periodoSelecionado.length"
            @click="aplicarPeriodo"
          >
            Aplicar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "HorarioPeriodoFiltro",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogPeriodo: false,
      periodoSelecionado: [],
      form: {
        data_inicio: null,
        data_fim: null,
      },
    };
  },
  computed: {
    datasPreenchidas() {
      return Boolean(this.form.data_inicio && this.form.data_fim);
    },
    periodoValido() {
      if (!this.datasPreenchidas) return false;
      return this.form.data_fim >= this.form.data_inicio;
    },
    dataFimErrors() {
      if (!this.datasPreenchidas || this.periodoValido) return [];
      return ["Data final não pode ser menor que a data inicial."];
    },
    botaoDesabilitado() {
      return this.disabled || !this.periodoValido;
    },
    periodoLabel() {
      if (!this.datasPreenchidas) return "Selecionar período";
      return `${this.formatarData(this.form.data_inicio)} a ${this.formatarData(
        this.form.data_fim
      )}`;
    },
  },
  methods: {
    aplicarPeriodo() {
      const [dataInicio, dataFim = dataInicio] = [...this.periodoSelecionado].sort();
      this.form.data_inicio = dataInicio;
      this.form.data_fim = dataFim;
      this.dialogPeriodo = false;
    },
    buscar() {
      if (this.botaoDesabilitado) return;
      this.$emit("buscar", { ...this.form });
    },
    gerarPdf() {
      if (this.botaoDesabilitado) return;
      this.$emit("gerar-pdf", { ...this.form });
    },
    gerarHighlights() {
      if (this.botaoDesabilitado) return;
      this.$emit("gerar-highlights", { ...this.form });
    },
    formatarData(data) {
      if (!data) return "";
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },
  },
};
</script>

<style scoped>
.horario-periodo-filtro {
  margin: 0;
}

.horario-periodo-filtro__date-btn {
  min-width: 250px;
  justify-content: flex-start;
  width: 100%;
}

.horario-periodo-filtro__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.horario-periodo-filtro__pdf-btn {
  margin-left: 0;
}

@media (max-width: 599px) {
  .horario-periodo-filtro__actions .v-btn {
    width: 100%;
  }
}
</style>
